import { Component, OnInit } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { BspListItem, BspService, BspSetupEdit } from '@app/services/bsp.service';

@Component({
  selector: 'tt-bsp-setup',
  templateUrl: './bsp-setup.component.html',
  styleUrls: ['./bsp-setup.component.css'],
  standalone: false,
})
export class BspSetupComponent implements OnInit {
    public page?: BspSetupEdit;

    public bsps: BspListItem[] = [];

    public executing = false;

    public rollbacking = false;

    public resetting = false;

    public nulling = false;

    public resettingData = false;

    constructor(
        private bsp: BspService,
        private modal: ModalService
    ) {}

    public async executeChanges(): Promise<void> {
        if (!this.page) return;

        this.executing = true;

        try {
            const result = await this.bsp.executeSetup(this.page);

            if (result.errorcode !== '0') await this.showError(result.errormessage);
            else window.location.reload();
        } finally { this.executing = false; }
    }

    public async rollbackValues(): Promise<void> {
        if (!this.page) return;

        this.rollbacking = true;

        try {
            if (!await this.confirm('confirm_message')) return;

            const result = await this.bsp.rollbackSetup(this.page);

            if (result.errorcode !== '0') await this.showError(result.errormessage);
            else window.location.reload();
        } finally { this.rollbacking = false; }
    }

    public async resetValues(): Promise<void> {
        this.resetting = true;

        try {
            if (!await this.confirm('do_you_really_want_to_reset_usergroups')) return;

            const result = await this.bsp.resetUsergroups();

            if (result.errorcode !== '0') await this.showError(result.errormessage);
            else this.page = await this.bsp.getSetup();
        } finally { this.resetting = false; }
    }

    public async nullDataValues(): Promise<void> {
        this.nulling = true;

        try {
            if (!await this.confirm('do_you_really_want_to_nulldata')) return;

            const result = await this.bsp.nullData();

            if (result.errorcode !== '0') await this.showError(result.errormessage);
            else window.location.reload();
        } finally { this.nulling = false; }
    }

    public async resetDataChanges(): Promise<void> {
        if (!this.page) return;

        this.resettingData = true;

        try {
            if (!await this.confirm('confirm_message')) return;

            const result = await this.bsp.resetTransactionData(this.page);

            if (result && result.errorcode !== '0') await this.showError(result.errormessage);
        } finally { this.resettingData = false; }
    }

    private async confirm(message: string): Promise<boolean> {
        return this.modal.openConfirmDialog({ type: 'danger', title: 'confirm_title', translateTitle: true, message, translateMessage: true, ok: 'confirm_ok_label', cancel: 'confirm_cancel_label' });
    }

    private async showError(message: string): Promise<void> {
        await this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message });
    }

    public async ngOnInit(): Promise<void> {
        [this.page, this.bsps] = await Promise.all([this.bsp.getSetup(), this.bsp.listBsps()]);
    }
}
